<template>
  <div class="footer-logo__wrapper">
    <a-visibility show :on="targetBreakpoints">
      <img
        :src="$helper.getLinkToFmBucketFile('header-logo-3.svg')"
        alt="Financial and Business News"
        title="Financial and Business News"
        class="footer-logo"
        loading="lazy"
      />
    </a-visibility>
  </div>
</template>

<script>
export default {
  name: 'AFooterLogo',
  computed: {
    targetBreakpoints() {
      return [
        this.$breakpoint.mobile,
        this.$breakpoint.desktopLg,
        this.$breakpoint.desktopXl,
        this.$breakpoint.aboveDesktopXl
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-logo__wrapper {
  flex-shrink: 0;

  @include mobile {
    margin: 30px 0;
  }

  .footer-logo {
    width: 140px;

    @include desktop-sm {
      width: 120px;
      height: 53px;
    }

    @include mobile {
      display: block;
      width: 100px;
      margin: 0 auto;
    }
  }

  .footer-logo-sm {
    width: 39px;
    height: 59px;
  }
}
</style>
